import Grid from "@mui/material/Grid";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { alphabetizeByProperty } from "utilities/arrays";
import { internalEventsList } from "./helpers";

export const InternalEvent = memo(
  ({ isEditMode }: { isEditMode?: boolean }) => {
    const { message } = useMessage();

    return (
      <Grid item xs={6} mt={12}>
        <SelectInput
          displaySearch
          name="event"
          data-test-id="campaign-trigger-event-type"
          items={
            alphabetizeByProperty(
              internalEventsList.map((element) => {
                return {
                  id: element.event,
                  label: message({
                    id: element.name,
                  }),
                };
              }),
              "name",
            ) || []
          }
          label={<RequiredFieldLabel text={message({ id: "eventType" })} />}
          disabled={isEditMode}
        />
      </Grid>
    );
  },
);
